import {account} from "@/app/utils/Account";

export default function (options) {
    return account().hasEngage ? options.fn(this) : options.inverse(this);
}